import './index.scss';
import React from 'react';
import { Check } from 'react-feather';
import Button from '../Button/Button';
import ButtonEnum from '../Button/ButtonEnum';

interface SuccessMessageProps {
  icon: any;
  title: string;
  buttonLabel?: string;
  onClick: () => void;
  waitingList?: boolean;
}

const SuccessMessage = ({
  icon,
  title,
  buttonLabel,
  onClick,
  waitingList,
}: SuccessMessageProps) => {
  return (
    <div className="success-message-wrapper">
      <div className="success-message-wrapper-icon">
        {icon}
        <div
          className="success-message-wrapper-sub-icon"
          style={{ backgroundColor: waitingList ? '#ea5455' : undefined }}
        >
          <Check color={waitingList ? 'white' : undefined} />
        </div>
      </div>
      <div className="success-message-wrapper-title">{title}</div>
      {buttonLabel && (
        <div className="success-message-wrapper-button">
          <Button
            text={buttonLabel}
            type={waitingList ? ButtonEnum.NOTIFICATION : ButtonEnum.PRIMARY}
            onClick={onClick}
          />
        </div>
      )}
    </div>
  );
};

export default SuccessMessage;
